import { CSSObject } from "@emotion/react";

import { colors } from "@dotnet/telematics-design-system";

import { DROPDOWN_SIZES } from "shared";

import { INPUT_FIELD_SIZES } from "..";

const useInputFieldStyles = () => {
    const {
        blue200,
        blue700,
        gray100,
        gray300,
        gray400,
        red100,
        red700,
        red800,
        textDisabled,
        textPlaceholder,
        white
    } = colors;

    const PADDINGS_TOP_OR_BOTTOM = {
        [INPUT_FIELD_SIZES.Tiny]: 2,
        [INPUT_FIELD_SIZES.Small]: 8,
        [INPUT_FIELD_SIZES.Medium]: 12
    };

    const boxShadow = (isError?: boolean) => {
        const color = isError ? red100 : blue200;

        return `-2px -2px 0px ${color}, -2px 2px 0px ${color}, 2px -2px 0px ${color}, 2px 2px 0px ${color}`;
    };

    const muiOutlinedInputStyles = (
        size: INPUT_FIELD_SIZES | DROPDOWN_SIZES,
        isDisabled?: boolean,
        isReadOnly?: boolean
    ): CSSObject => ({
        background: isDisabled || isReadOnly ? gray100 : white,
        borderRadius: "6px",
        padding: `${PADDINGS_TOP_OR_BOTTOM[size]}px 12px`,

        "& input": {
            transitionDelay: "9999s",
            transitionProperty: "background-color"
        },

        "& .MuiOutlinedInput-notchedOutline": {
            borderColor: gray300
        },

        "&:hover": {
            "& .MuiOutlinedInput-notchedOutline": {
                borderColor: gray400
            },

            "&.Mui-disabled": {
                "& .MuiOutlinedInput-notchedOutline": {
                    borderColor: gray300
                }
            },

            "&.Mui-error": {
                "& .MuiOutlinedInput-notchedOutline": {
                    borderColor: red700
                }
            },

            "&.Mui-error:not(.Mui-disabled)": {
                "& .MuiOutlinedInput-notchedOutline": {
                    borderColor: red800
                }
            }
        },

        "&.Mui-focused": {
            "& .MuiOutlinedInput-notchedOutline": {
                borderColor: blue700,
                borderWidth: "1px",
                boxShadow: boxShadow()
            },

            "&.Mui-error": {
                "& .MuiOutlinedInput-notchedOutline": {
                    borderColor: red700,
                    boxShadow: boxShadow(true)
                }
            }
        },

        "&.Mui-disabled": {
            "& .MuiOutlinedInput-notchedOutline": {
                borderColor: gray300
            }
        },

        "&.Mui-error": {
            "& .MuiOutlinedInput-notchedOutline": {
                borderColor: red700
            }
        },

        "& .MuiOutlinedInput-input": {
            height: "unset",
            padding: "0",

            "&.Mui-disabled": {
                color: textDisabled,
                WebkitTextFillColor: textDisabled
            },

            "&::placeholder": {
                color: textPlaceholder,
                lineHeight: "20px",
                opacity: "1"
            }
        }
    });

    const circularProgressSize = (size: INPUT_FIELD_SIZES | DROPDOWN_SIZES) =>
        size === DROPDOWN_SIZES.Tiny ? 12 : 16;

    return {
        PADDINGS_TOP_OR_BOTTOM,
        muiOutlinedInputStyles,
        boxShadow,
        circularProgressSize
    };
};

export { useInputFieldStyles };
